export default {
  activeRequests: 0,
  data: {},
  host: '',
  whiteLabel: '',
  urlParams: ''
}
